module.exports = __webpack_public_path__ + "img/ltktravel-1x.da79bd8.jpg";